import { useEffect, useState } from "react";
import "./gallary.css";

export default function Access() {
  const [apilink, setapilink] = useState("https://gallary.rbhardwaj.com/");
  const API = `${apilink.replace(/\/$/, "")}/upload-api.php`;

  const [files, setFiles] = useState([]);
  const [filter, setFilter] = useState("all");
  const [modalItem, setModalItem] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploading, setUploading] = useState(false);

  // ================= FETCH FILES =================
  const fetchFiles = async () => {
    try {
      const res = await fetch(`${API}?action=list`);
      const data = await res.json();
      console.log(data);
      setFiles(Array.isArray(data.files) ? data.files : []);
    } catch (err) {
      console.error("Failed to fetch files", err);
      setFiles([]);
    }
  };

  // reload when site changes
  useEffect(() => {
    setFiles([]);
    setModalItem(null);
    fetchFiles();
  }, [apilink]);

  // ================= UPLOAD WITH PROGRESS =================
  const upload = (e) => {
    const selected = Array.from(e.target.files);
    if (!selected.length) return;

    const formData = new FormData();

    selected.forEach((file) => {
      formData.append("files[]", file);
      formData.append("paths[]", file.webkitRelativePath || file.name);
    });

    const xhr = new XMLHttpRequest();
    xhr.open("POST", `${API}?action=upload`);

    setUploading(true);
    setUploadProgress(0);

    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        setUploadProgress(Math.round((event.loaded / event.total) * 100));
      }
    };

    xhr.onload = () => {
      setUploading(false);
      setUploadProgress(0);
      fetchFiles();
    };

    xhr.onerror = () => {
      console.error("Upload failed");
      setUploading(false);
    };

    xhr.send(formData);
    e.target.value = "";
  };

  // ================= DELETE =================
  const deleteFile = async (fullPath) => {
    if (!window.confirm("Delete this file?")) return;

    try {
      await fetch(`${API}?action=delete`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ path: fullPath }),
      });
      fetchFiles();
    } catch (err) {
      console.error("Delete failed", err);
    }
  };

  // ================= FILTER =================
  const filteredItems =
    filter === "all" ? files : files.filter((item) => item.type === filter);

  return (
    <div className="app">
      {/* HEADER */}
      <header className="header">
        <h1 style={{ fontFamily: "fantasy", fontWeight: "400" }}>Gallery</h1>

        <select
          onChange={(e) => setapilink(e.target.value)}
          style={{ display: "none" }}
        >
          <option value="https://gallary.rbhardwaj.com">Gallery</option>
        </select>

        <div style={{ padding: "15px 0px" }}>
          <label className="upload-btn">
            Upload folder
            <input
              type="file"
              multiple
              webkitdirectory="true"
              hidden
              onChange={upload}
            />
          </label>
          &nbsp;
          <label className="upload-btn">
            Upload files
            <input type="file" multiple hidden onChange={upload} />
          </label>
        </div>
      </header>

      {/* UPLOAD PROGRESS */}
      {uploading && (
        <div className="upload-progress">
          <div
            className="progress-bar"
            style={{ width: `${uploadProgress}%` }}
          />
          <span>{uploadProgress}%</span>
        </div>
      )}

      {/* FILTERS */}
      <div
        style={{
          position: "sticky",
          top: "0px",
          backgroundColor: "white",
          zIndex: "100",
        }}
      >
        {/* <div style={{ display: "flex", overflow: "auto" }}>
        {[
          "SmmO7qwhtnM",
          "HV-ycwEcJ1s",
          "NOIesnBDcsk",
          "K8I8heCZfbc",
          "6MAdbh-YzeY",
          "LxuWhcPU4bg",
          "SSRpbxHqvrc",
        ].map((id) => (
          <iframe
            key={id}
            src={`https://www.youtube.com/embed/${id}`}
            title={id}
            frameBorder="0"
            allowFullScreen
          />
        ))}
      </div> */}
        <div className="filters">
          {["all", "image", "video", "file"].map((f) => (
            <button
              key={f}
              className={filter === f ? "active" : ""}
              onClick={() => setFilter(f)}
            >
              {f === "all"
                ? "All"
                : f === "image"
                  ? "Images"
                  : f === "video"
                    ? "Videos"
                    : "Files"}
            </button>
          ))}
        </div>
      </div>

      {/* GALLERY */}
      <div className="gallery">
        {filteredItems.length === 0 && <p className="empty">No media found</p>}

        {filteredItems.map((f) => {
          const fullPath =
            f.path && f.path !== "." ? `${f.path}/${f.name}` : f.name;

          return (
            <div className="card" key={fullPath}>
              <div className="preview" onClick={() => setModalItem(f)}>
                {f.type === "image" ? (
                  <img src={f.url} alt={f.name} loading="lazy" />
                ) : f.type === "video" ? (
                  <>
                    <video src={f.url} muted loading="lazy" />
                    <span className="play">▶</span>
                  </>
                ) : (
                  <div
                    className="file-icon"
                    style={{
                      fontSize: "100px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    📄
                  </div>
                )}
              </div>

              <div className="card-footer">
                <span className="title" title={f.url}>
                  {f.name}
                </span>
                <div className="card-footer-links">
                  <a
                    onClick={() => {
                      const pagelink = {
                        title: f.name,
                        text: "share file",
                        url: f.url,
                      };

                      if (navigator.share) {
                        navigator
                          .share(pagelink)
                          .then(() => console.log("Shared successfully"))
                          .catch((err) => console.log("Share failed:", err));
                      } else {
                        alert("Web Share API not supported!");
                      }
                    }}
                  >
                    <i
                      class="material-icons"
                      style={{ color: "green", fontSize: "20px" }}
                    >
                      &#xe80d;
                    </i>
                  </a>
                 

                  <a href={f.url} download rel="noreferrer">
                    <i className="material-icons">download</i>
                  </a>
                  <button
                    onClick={() => deleteFile(fullPath)}
                    style={{ color: "red" }}
                  >
                    <i class="material-icons">&#xe872;</i>
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* MODAL */}
      {modalItem && (
        <div className="modal" onClick={() => setModalItem(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close" onClick={() => setModalItem(null)}>
              ✕
            </button>

            {modalItem.type === "image" ? (
              <img src={modalItem.url} alt={modalItem.name} />
            ) : modalItem.type === "video" ? (
              <video src={modalItem.url} controls autoPlay />
            ) : (
              <iframe src={modalItem.url} title={modalItem.name} />
            )}
          </div>
        </div>
      )}
    </div>
  );
}
